$(function() {
    $('.social-feeds__ajax-container').each(function(){
        $(this).load($(this).data('url'));
    });
});
